<template>
  <div v-loading="state.loading">
    <br />

    <el-input v-model="state.filterText" placeholder="Поиск"></el-input>
    <br />
    <br />
    <div id="goods-remains">
      <div class="products-report__head__storages">
        <div
          class="products-report__tree__storages__item"
          v-for="storage in storages"
        >{{storage.name}}</div>
      </div>
      <el-tree
        :data="categoriesTree"
        v-if="categoriesTree.length"
        node-key="id"
        ref="tree"
        :filter-node-method="filterNode"
      >
        <div slot-scope="{node, data}" style="width: 100%;">
          <div>
            <div class="products-report__tree__name">
              <div v-if="!data.isProduct">{{data.name}}</div>
              <div v-if="data.isProduct">
                <router-link :to="{name: 'Goods.edit', params: {id: data.id}}">{{data.name}}</router-link>
              </div>
            </div>
          </div>

          <div class="products-report__tree__storages">
            <div class="products-report__tree__storages__item" v-for="storage in storages">
              <span v-if="data.storages && data.storages[storage.id]">
                <span style="color: green;">{{data.storages[storage.id].count}}</span>
              </span>
            </div>
          </div>
        </div>
      </el-tree>
    </div>
  </div>
</template>
<script>
import {
  getGoodStorages,
  getCategories,
  getGoods,
  getPlaces
} from "../../../api";
import { loadProductsTree } from "@/api/global";
import { loadTree } from "../../../services/treeServices";
import { findIndex } from "lodash";
import { getProducts } from "@/modules/products/api";
import { mapTree } from "@/utils/products";
import mapStoragesToProducts from "../../../services/mapStorageToProducts";

export default {
  name: "storage_and_goods_goods_list",
  data() {
    return {
      state: {
        loading: true,
        filterText: ""
      },
      categories: [],
      goodsList: [],
      goodsStorages: [],
      places: [],
      defaultExpanded: [],
      categoriesTree: [],
      storages: []
    };
  },
  watch: {
    "state.filterText": {
      handler(val) {
        this.$refs.tree.filter(val);
      }
    }
  },
  props: ["api"],
  created() {
    if (this.api && !this.api.print) {
      this.api.print = this.printRemains;
    }
    this.loadProductsTree();
  },
  methods: {
    printRemains() {
      if (this.state.loading) {
        this.$message.error("Дождитесь загрузки данных");
        return;
      }
      //        this.defaultExpanded = this.products.map(({id}) => id)
      //        this.$forceUpdate()
      setTimeout(() => {
        let tree = document.querySelector("#goods-remains").cloneNode(true);
        tree.className = "goods-remains_for-print";

        let body = document.querySelector("body");
        body.className = "body_for-print";

        setTimeout(() => {
          body.appendChild(tree);
          window.print();
          body.className = "";
          tree.remove();
        });
      });
    },
    async loadProductsTree() {
      this.state.loading = true;
      Promise.all([
        loadProductsTree(),
        getPlaces(),
        getGoodStorages(),
        getProducts({ "multysearch[status.statusId]": "1,2" })
      ]).then(response => {
        this.categories = response[0].data.items;
        this.products = response[3].data.items;

        this.storages = response[1].data.items;
        this.storageToProducts = response[2].data.items
          ? response[2].data.items
          : response[2].data;

        mapStoragesToProducts(
          this.products,
          this.storages,
          this.storageToProducts
        );
        this.categoriesTree = mapTree(this.categories, this.products);

        this.defaultExpanded = this.categoriesTree.map(({ id }) => id);
        this.state.loading = false;
      });
    },
    async onDateChange() {
      this.loadProductsTree();
    },
    filterNode(value, data, node) {
      if (!value) return true;

      let includes =
        data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      return includes || this.checkNodeParent({ node, value });
    },
    checkNodeParent({ node, value }) {
      if (!node.parent || !node.parent.data.name) {
        return false;
      }

      let includes =
        node.parent.data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;

      if (node.parent.parent) {
        return includes || this.checkNodeParent({ node: node.parent, value });
      } else {
        return includes;
      }
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/modules/productsStorage/components/storageAndGoods/tabs/goods.vue